import axios from 'axios';
import get from 'lodash/get';
import * as types from '../constants/ActionTypes';

function requestHelpCenterAlerts() {
  return {
    type: types.REQUEST_HELPCENTER_ALERTS,
  };
}

function receiveHelpCenterAlerts(alerts) {
  return {
    type: types.RECEIVE_HELPCENTER_ALERTS,
    payload: { alerts },
  };
}

function receiveHelpCenterAlertsError() {
  return {
    type: types.RECEIVE_HELPCENTER_ALERTS_ERROR,
  };
}

export default function getHelpCenterAlerts(isHomePage = false) {
  return (dispatch) => {
    dispatch(requestHelpCenterAlerts());
    return axios.get(`/smarthelp/web-alerts?homepage=${isHomePage}`)
      .then((response) => {
        const alerts = get(response, 'data.webAlerts');
        dispatch(receiveHelpCenterAlerts(alerts));
      })
      .catch(() => {
        dispatch(receiveHelpCenterAlertsError());
      });
  };
}



// WEBPACK FOOTER //
// ./contactUs/actions/actions-helpcenter-alerts.js